import React, { useEffect, useState } from "react";
import Navbar from "../Component/Navbar";
import "./Courses.css";

export default function Courses() {

  const [open, setOpen] = useState(false);
  const [role, setRole] = useState("");

  useEffect(() => {
    const elements = document.querySelectorAll(".fade-section");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) =>
        entry.target.classList.toggle("visible", entry.isIntersecting)
      );
    }, { threshold: 0.2 });

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const modulesPlanA = [
    { module: "Module 1", name: "Core level C language", hours: "7 days (42 hours)" },
    { module: "Module 2", name: "Advanced C language", hours: "7 days (42 hours)" },
    { module: "Module 3", name: "OOPS", hours: "5 days (30 hours)" },
    { module: "Module 4", name: "Java or Python", hours: "7 days (42 hours)" },
    { module: "Module 5", name: "DSA", hours: "7 days (42 hours)" },
    { module: "Module 6", name: "Problem Solving", hours: "7 days (42 hours)" },
    { module: "Module 7", name: "Aptitude", hours: "12 days (72 hours)" },
    { module: "Module 8", name: "Soft Skills", hours: "5 days (30 hours)" },
  ];

  return (
    <div className="courses-page">

      <Navbar />

      <h1 className="course-heading fade-section">
        Program Plans: Tailored to Your Learning Goals
      </h1>

      {/* ============ PLAN A ============ */}
      <div className="course-container fade-section">

        <table className="course-table">
          <thead>
            <tr>
              <th>TRAINING MODULES</th>
              <th>NO. OF HOURS</th>
            </tr>
          </thead>

          <tbody>
            {modulesPlanA.map((item, index) => (
              <tr key={index}>
                <td>{item.module} — {item.name}</td>
                <td>{item.hours}</td>
              </tr>
            ))}
            <tr className="total-row">
              <td>Total</td>
              <td>300 hours</td>
            </tr>
          </tbody>
        </table>

        <div className="course-plan-box">
          <h2>Plan A: 300–340 Hours</h2>
          <h3>Intensive Comprehensive Training</h3>
          <p>
            This program builds strong fundamentals in programming, DSA,
            operating systems, project development and real-world interview preparation.
          </p>
        </div>
      </div>

      {/* ============ PLAN B ============ */}
      <div className="course-container fade-section">

        <table className="course-table">
          <thead>
            <tr>
              <th>TRAINING MODULES</th>
              <th>NO. OF HOURS</th>
            </tr>
          </thead>

          <tbody>
            <tr><td>Module 1 — Core C / Java / Python</td><td>40 hours</td></tr>
            <tr><td>Module 2 — OOPS Concepts</td><td>20 hours</td></tr>
            <tr><td>Module 3 — Basic DSA</td><td>40 hours</td></tr>
            <tr><td>Module 4 — Aptitude</td><td>30 hours</td></tr>
            <tr><td>Module 5 — Mini Project</td><td>30 hours</td></tr>
            <tr className="total-row"><td>Total</td><td>200–240 hours</td></tr>
          </tbody>
        </table>

        <div className="course-plan-box">
          <h2>Plan B: 200–240 Hours</h2>
          <h3>Essential Skill Development</h3>
          <p>
            Covers core programming, OOPS, basic DSA, aptitude, and a practical mini-project.
          </p>
        </div>
      </div>

      {/* ============ PLAN C ============ */}
      <div className="course-container fade-section">

        <table className="course-table">
          <thead>
            <tr>
              <th>TRAINING MODULES</th>
              <th>NO. OF HOURS</th>
            </tr>
          </thead>

          <tbody>
            <tr><td>Module 1 — Programming Fundamentals</td><td>35 hours</td></tr>
            <tr><td>Module 2 — OOPS</td><td>15 hours</td></tr>
            <tr><td>Module 3 — Basic DSA</td><td>30 hours</td></tr>
            <tr><td>Module 4 — Aptitude</td><td>20 hours</td></tr>
            <tr><td>Module 5 — Interview Training</td><td>20 hours</td></tr>
            <tr className="total-row"><td>Total</td><td>120–150 hours</td></tr>
          </tbody>
        </table>

        <div className="course-plan-box">
          <h2>Plan C: 120–150 Hours</h2>
          <h3>Focused Career Starter</h3>
          <p>
            A structured program focusing on one programming language,
            fundamentals, DSA and interview preparation.
          </p>
        </div>
      </div>

      {/* ============ PLAN D ============ */}
      <div className="course-container fade-section">

        <table className="course-table">
          <thead>
            <tr>
              <th>TRAINING MODULES</th>
              <th>NO. OF HOURS</th>
            </tr>
          </thead>

          <tbody>
            <tr><td>Module 1 — Programming Basics</td><td>25 hours</td></tr>
            <tr><td>Module 2 — Aptitude + Reasoning</td><td>20 hours</td></tr>
            <tr><td>Module 3 — Interview Training</td><td>15 hours</td></tr>
            <tr><td>Module 4 — Mock Tests</td><td>10 hours</td></tr>
            <tr className="total-row"><td>Total</td><td>60–80 hours</td></tr>
          </tbody>
        </table>

        <div className="course-plan-box">
          <h2>Plan D: 60–80 Hours</h2>
          <h3>Crash Course & Fast-Track Training</h3>
          <p>
            Quick upskilling for students who need immediate interview preparation
            and strong fundamentals in a short time.
          </p>
        </div>
      </div>

      {/* KEEP YOUR EXISTING CONTENT BELOW THIS LINE (UNCHANGED) */}
      {/* ================= WHAT YOU WILL LEARN ================= */}
      <section className="course-details fade-section">
        <h2>What Will You Learn?</h2>
        <ul>
          <li>Master programming fundamentals using C, Java or Python.</li>
          <li>Object-Oriented Programming and advanced DSA concepts.</li>
          <li>Competitive coding & real-world problem-solving.</li>
          <li>Professional aptitude & interview readiness.</li>
          <li>Communication & corporate soft skill training.</li>
        </ul>
      </section>

      <section className="course-details fade-section">
        <h2>Career Opportunities</h2>
        <ul>
          <li>Software Developer / Full Stack Developer</li>
          <li>Python / Java Developer</li>
          <li>DevOps / Cloud Engineer</li>
          <li>Data Analyst / ML Engineer</li>
          <li>Technical Support / Associate Engineer</li>
        </ul>
      </section>
      <section className="course-details fade-section">
        <h2>Training Methodology</h2>
        <ul>
          <li>Live interactive classes with task-based learning</li>
          <li>Mini projects + one major project</li>
          <li>Mock interviews & resume preparation</li>
          <li>Weekly assessments & mentor support</li>
        </ul>
      </section>

      {/* (YOUR CAREER, TRAINING, PLACEMENT SECTIONS REMAIN SAME) */}

      <div className="enroll-container fade-section">
        <button className="enroll-btn" onClick={() => setOpen(true)}>Join the Program</button>
      </div>

      {/* ===== MODAL ===== */}
      {open && (
        <div className="modal-overlay">
          <div className="modal-box">

            <h2>Register for the Program</h2>

            <form className="form">
              <label>Full Name</label>
              <input type="text" placeholder="Enter your name" />

              <label>Are you a</label>
              <select onChange={(e) => setRole(e.target.value)}>
                <option>Select option</option>
                <option>College Student</option>
                <option>Working Professional</option>
              </select>

              {role === "College Student" && (
                <>
                  <label>College Name</label>
                  <input type="text" placeholder="Enter college name" />

                  <label>Year</label>
                  <input type="text" placeholder="3rd year / Final year" />
                </>
              )}

              {role === "Working Professional" && (
                <>
                  <label>Company Name</label>
                  <input type="text" placeholder="Enter company name" />

                  <label>Years of Experience</label>
                  <input type="number" placeholder="0 - 10 years" />
                </>
              )}

              <label>Select Course</label>
              <select>
                <option>MERN Full Stack</option>
                <option>AWS Cloud & DevOps</option>
                <option>Python & Machine Learning</option>
                <option>Cyber Security</option>
              </select>

              <button className="submit-btn">Submit</button>
            </form>

            <button className="close-btn" onClick={() => setOpen(false)}>×</button>
          </div>
        </div>
      )}

    </div>
  );
}
